import axiosClient from './AxiosClient';

const UserService = {
    login(data) {
        var url = '/user/login'

        return axiosClient.post(url, {
            username: data.username,
            password: data.password
        });
    },
};

export default UserService;